import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api'; // centralized axios instance
import PasswordInput from '../components/PasswordInput';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Debug logging
  console.log('Reset Password Page - Token:', token);
  console.log('Reset Password Page - Full URL:', window.location.href);
  console.log('Reset Password Page - Search params:', window.location.search);

  // Suggestion: password strength checker (future)
  // const [passwordStrength, setPasswordStrength] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    // Simple password validation (expand as needed)
    if (!password || password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      // Fixed: Backend expects 'newPassword', not 'password'
      const { data } = await api.post('/auth/reset-password', { token, newPassword: password });
      setMessage(data.message || 'Password reset successfully.');
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred.');
    } finally {
      setLoading(false);
    }
  };

  if (!token || token.length < 10) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h3>Invalid or Expired Link</h3>
          <p>
            This password reset link is not valid or has expired.<br />
            Please request a new one.
          </p>
          <div style={{ marginTop: '1rem', padding: '0.5rem', backgroundColor: '#f5f5f5', borderRadius: '4px', fontSize: '0.8rem', color: '#666' }}>
            <strong>Debug Info:</strong><br />
            URL: {window.location.href}<br />
            Token found: {token ? 'Yes' : 'No'}<br />
            Token length: {token ? token.length : 0}
          </div>
          <Link to="/forgot-password" className="muted-link" style={{ marginTop: '1rem', display: 'block' }}>
            Request New Reset Link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h3>Reset Your Password</h3>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <PasswordInput
              id="password"
              label="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter new password"
              autoComplete="new-password"
              required
              minLength={8}
              error={error && password.length > 0 && password.length < 8 ? "Password must be at least 8 characters" : ""}
            />
            {/* {passwordStrength && <small>Password strength: {passwordStrength}</small>} */}
          </div>
          <div className="form-group">
            <PasswordInput
              id="confirmPassword"
              label="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
              autoComplete="new-password"
              required
              error={error && confirmPassword.length > 0 && password !== confirmPassword ? "Passwords do not match" : ""}
            />
          </div>

          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}

          <button
            type="submit"
            className="action-button"
            disabled={loading || !!message}
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>

        {message && (
          <Link
            to="/login"
            className="muted-link"
            style={{ display: 'block', textAlign: 'center', marginTop: '1rem' }}
          >
            Proceed to Login
          </Link>
        )}
        <Link to="/login" className="muted-link" style={{ marginTop: '1rem', display: 'block' }}>
          Back to Login
        </Link>
      </div>
    </div>
  );
}

export default ResetPasswordPage;